<template>
  <div style="height:100%">
    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      :reprint="notify.reprint" :rePrintData="notify.rePrintData"
                      @dialogClose="notify.show = false"></my-notify-dialog>

    <div class="common-page-box">
      <div class="back-btn" @click="$router.back()">
        <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
      </div>

      <div class="page-title" style="margin-top:48px">{{ title }}</div>

      <div class="card" style="margin:56px 96px 96px;flex:1;padding:72px 120px;display:flex;flex-direction:column">
        <template v-if="!showApplyList">
          <div class="field-row">
            <span class="field-label">{{ field }}</span>
            <input class="ta-input" placeholder="请输入手机号" v-model="inputCode" maxlength="11">
            <button class="ta-btn primary" style="height:112px;padding:0 72px" @click="onEnsureClick">搜 索</button>
          </div>
          <div v-if="agreement.valid" class="agree" style="margin-top:36px;margin-left:176px" @click="haveRead = !haveRead">
            <span class="box" :class="{ checked: haveRead }">
              <svg v-if="haveRead" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5.5 5.5L20 6.5"/></svg>
            </span>
            <span>请阅读并同意<a>《{{ agreementTitle }}</a></span>
          </div>

          <div class="notice" style="margin-top:auto;border-top:1px solid var(--line);padding-top:48px">
            <h3>{{ agreementTitle }}</h3>
            <div v-if="agreement.valid" v-html="agreement.content"></div>
            <div v-else>欢迎来访！签到前请注意：<br>
            1. 请出示预约二维码、访客码或预留手机号完成签到；<br>
            2. 请在访客区域内活动，服从工作人员安排；<br>
            3. 请勿进入未授权区域，注意人身与财物安全。<br>
            如有疑问，请联系前台工作人员。</div>
          </div>
        </template>

        <el-table v-else :data="applyList" style="width:100%">
          <el-table-column prop="myVisitorName" label="访客"></el-table-column>
          <el-table-column prop="myEmployeeName" label="受访者"></el-table-column>
          <el-table-column prop="myBeginTime" label="开始时间"></el-table-column>
          <el-table-column prop="myEndTime" label="结束时间"></el-table-column>
          <el-table-column prop="myStatus" label="状态">
            <template v-slot="scope">
              <el-tag>{{ scope.row.myStatus | tableDateFilter }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button :disabled="scope.row.myStatus !== 'PASS'" @click="doSignEnter(scope.row.data)"
                         type="success">
                预约详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>


import BackIcon from "@/components/BackIcon";

import {getApplyListByVisitCode, visitorSearchByPhoneNo} from "@/api/visit-api";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import {areaCheckMixin} from "@/utils/myMixins";
import {usual_visitor_sign_mixin} from "@/helper/usual_visitor_mixin";
import {myPath} from "@/utils/constant";

export default {
  name: "VisitCodeCome",
  components: {MyNotifyDialog, BackIcon},
  mixins: [areaCheckMixin, usual_visitor_sign_mixin],

  mounted() {
    this.setupAreaInfo()
  },
  // get visitorAgreement from store
  computed: {
    agreement() {
      return this.$store.state.signEnterAgreement
    },

  },
  data() {
    return {
      title: "手机号签到",

      subTitle: "手机号",
      inputCode: "",
      haveRead: false,

      applyList: [],
      showApplyList: false,

      agreementTitle: "签到须知",

    }
  }, // end data

  methods: {

    onCancelClick() {
      this.$router.back()
    },
    onEnsureClick() {
      if (!this.haveRead && this.agreement.valid) {
        this.$message.warning("请先阅读并同意" + this.agreementTitle)
        return
      }
      let tel = this.inputCode
      if (!tel || tel.length !== 11) {
        this.$message.warning("请输入手机号")
        return
      }

      visitorSearchByPhoneNo(tel).then(({data}) => {
        console.log("visitorSearchByPhoneNo", data)
        if (data.code === 200) {
          if (data.data.length === 0) {
            this.$message.warning("未找到对应的访客信息")
            return
          }
          let visitor = data.data[0]
          this.doOnGetVisitor(visitor)
        } else {
          this.showNetErrMsg(data.code)
          this.logE("VisitCodeCome visitorSearchByPhoneNo false", data.code, data.msg)
        }
      }).catch((err) => {
        this.logE("VisitCodeCome visitorSearchByPhoneNo err", err)
        this.showNetErrMsg()
      })

      this.applyList = []
    },

    doOnGetVisitor(visitor) {
      if (this.checkIsVisitorUsual(visitor)) {
        let areaId = this.$store.state.areaId
        let deviceId = this.$store.state.deviceId
        this.doUsualSignEnter(visitor, deviceId, areaId)
        return
      }

      this.selectVisitorDialogVisible = false
      this.selectVisitor = visitor

      getApplyListByVisitCode(visitor.code).then(({data}) => {
        console.log("getApplyListByVisitCode", data)
        this.applyList = []
        if (data.code === 200) {
          let applyList = data.data
          if (applyList.length > 0) {
            applyList.forEach(item => {
              this.applyList.push({
                myVisitorName: item.visitor.name,
                myEmployeeName: (item.employee || {}).name,
                myBeginTime: item.beginDate + " " + item.beginTime,
                myEndTime: item.endDate + " " + item.endTime,
                myStatus: item.state,
                data: item
              })
            })
            this.showApplyList = true;
            if (this.applyList.length === 1 && this.applyList[0].myStatus === "PASS") {
              this.doSignEnter(this.applyList[0].data)
            }
          } else {
            this.$message.warning("查询失败，未能找到对应的申请记录")
          }
        } else {
          this.showNetErrMsg(data.code)
          this.logE("VisitCodeCome getApplyListByVisitCode false", data.code, data.msg)
        }
      }).catch((err) => {
        this.logE("VisitCodeCome getApplyListByVisitCode err", err)
        this.showNetErrMsg()
      })

    },

    jumpToPrintPage(signResult) {
      let applyInfo = signResult.apply
      let visitor = signResult.visitor
      let reasonObj = applyInfo.forms.find(item => item.name === "reason")
      let reason = reasonObj ? reasonObj.value : ""
      let carObj = applyInfo.forms.find(item => item.name === "carNumber")
      let car = carObj ? carObj.value : ""
      let printData = {
        visitorName: visitor.name,
        visitorCode: signResult.pinCode,
        visitorCompany: visitor.company,
        visitorReason: reason,
        employName: applyInfo.employee.name,
        employDepartment: applyInfo.employee.departmentName,
        visitorCar: car,
        visitorTime: applyInfo.beginDate + " " + applyInfo.beginTime,
        visitorGoods: "",
        idCardNo: visitor.ic,
        visitorPhone: visitor.tel,
      }
      this.$router.push({name: myPath.printPage, params: {printData: printData}})
    },

    doSignEnter(applyInfo) {
      this.$router.push({name: myPath.signEnter, params: {applyInfo: applyInfo, visitorInfo: this.selectVisitor}})
    },
    onDialogEnsure() {
      this.agreementDialogVisible = false
      this.haveRead = true
    },
  }, // end methods

  filters: {
    tableDateFilter(value) {
      switch (value) {
        case 'PASS':
          return "审批通过"
        case 'REJECT':
          return "审批拒绝"
        case 'CANCEL':
          return "审批撤销"
        case 'PROCESS ':
        case 'NONE ':
        default:
          return "审批中"
      }
    }
  }

}
</script>
<style scoped lang="less">
.back-btn {
  position: absolute;
  top: 88px;
  right: 72px;
  z-index: 20;
  width: 104px;
  height: 104px;
  border-radius: 50%;
  background: var(--panel);
  border: 1px solid var(--line);
  box-shadow: var(--shadow-card);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
